import axios from 'axios'
import router from './router'
import store from './store'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': '*',
  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
  Accept: 'application/json',
  'Content-Type': 'application/json'

}

if (localStorage.hasOwnProperty('token') && localStorage.getItem('token')) {
  axios.defaults.headers.common.Authorization = localStorage.getItem('token')
  $.ajaxSetup({
    headers: {
      Accept: 'application/json',
      Authorization: localStorage.getItem('token')
    }
  })
} else {
  axios.defaults.headers.common.Authorization = null
  $.ajaxSetup({
    headers: {
      Accept: 'application/json',
      Authorization: null
    }
  })
}

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response
}, function (error) {
  // Do something with response error
  if (error.response && error.response.status && error.response.status === 401) {
    localStorage.removeItem('token')
    store.state.logged_in = false
    store.state.has_pending_loan = false
    store.state.borrow = {
      name: '',
      last_name: '',
      phone: '',
      email: '',
      amountBorrow: '',
      amountDate: '',
      loanType: 'Payday',
      borrower_photo: ''
    }
    router.push({ name: 'login' })
  }
  return Promise.reject(error)
})

export default axios
